<template>
  <div class="legal-view view">

    <div class="legal-content-view content-view">
      <div class="lv-header">LEGAL</div>

      <div class="lv-rules-container" ref="lvRulesContainer">
        <div class="lv-rules">
          <p>NO PURCHASE IS NECESSARY TO ENTER OR WIN. A PURCHASE DOES NOT INCREASE THE CHANCES OF WINNING.</p>

          <ol>
            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</li>

            <li>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione vol</li>

            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</li>

            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</li>

            <li>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione vol</li>

            <li>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</li>

          </ol>
        </div>
      </div>

      <div class="lv-close-btn" @click="handleCloseBtnClicked"></div>
    </div>

  </div>
</template>

<script>
import { ref, computed, watch, onBeforeMount, onMounted } from '@vue/composition-api';
import gsap from 'gsap';

export default {
  name: 'Legal',
  components: {

  },

  setup(props, context) {

    const {
      $store
    } = context.root;

    // Refs
    const lvRulesContainer = ref(null);

    // Properties
    const legalVisible = computed(() => {
      // return context.root.$store.getters['general/getLegalVisible'];
      return context.root.$store.state.general.legalVisible;
    })

    // Sample of watch() syntax
    //  watch(count, (count, prevCount) => { /* ... */ })
    watch(legalVisible, (newLegalVisible, prevLegalVisible) => {
      console.log('watch legalVisible');
      console.log('prev value:', prevLegalVisible);
      console.log('new value:', newLegalVisible);

      if( newLegalVisible === true && prevLegalVisible === false ) {
        scrollToTop();
      }
    })

    /**
     * Vue Hooks
     */
    onMounted(() => {

    });

    /**
     * Methods
     */
    const handleCloseBtnClicked = () => {
      $store.dispatch('general/setLegalVisible', false, {root:true});
    }

    const scrollToTop = () => {
      gsap.set(lvRulesContainer.value, {scrollTo:0});
    }

    return {
      lvRulesContainer,
      legalVisible,
      handleCloseBtnClicked,
    }
  },
}
</script>

<style lang="scss" scoped>

$padding-top: 200px;
$mobile-padding-top: 23vh;

.legal-view {
  padding-top: #{$padding-top};
  overflow-y: hidden;
  z-index: 100;
  user-select: auto;
}

.legal-content-view {
  position: relative;
  font-size: 2rem;
  // height: calc(var(--vh, 1vh) * 100 - 34vh - 1.1em);
  height: calc(var(--vh, 1vh) * 100 - #{$padding-top});
  // overflow-y: auto;
  // width: 90%;
  // margin: 1em auto 0 auto;
  text-align: left;
}

.lv-header {
  @include font-knewave;
  color: $font-dark-blue-color;
  font-size: 2rem;
  height: 1.1em;
  text-align: center;
}

.lv-rules-container {
  position: absolute;
  height: calc(var(--vh, 1vh) * 100 - 34vh - 1.1em);
  // height: calc(var(--vh, 1vh) * 100 - 20vh - 1.1em);
  // height: 350px;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 80%;
  left: 10%;
  margin: 1em auto 0 auto;
  text-align: left;
  background-color: rgba(0, 0, 0, 0);
  // -webkit-overflow-scrolling: touch;

}

.lv-rules {
  position: absolute;
  font-size: 0.8em;
  // pointer-events: none;
  // user-select: none;

  &::v-deep p {
    margin-top: 0;
    margin-bottom: 0;
  }

  ol {
    font-size: 0.8em;
    padding-left: 2em;
    margin-top: 1em;
  }

  li {
    text-align: left;
    margin-bottom: 1em;
  }
}

.lv-close-btn {
  position: absolute;
  width: 2rem;
  height: 2rem;
  right: 10%;
  top: -5%;
  background-image: url('~@/assets/images/close_btn.png');
  background-size: contain;
  background-repeat: no-repeat;
}

@include mobile {
  .legal-view {
    padding-top: #{$mobile-padding-top};
  }

  .legal-content-view {
    height: calc(var(--vh, 1vh) * 100 - #{$mobile-padding-top});
  }
}

@include mobile-small {

}
</style>
